'use client';
import { ToastContainer } from 'react-toastify';
import styles from './toastProvider.module.scss';

interface ToastProviderProps {
  children: React.ReactNode;
}

export default function ToastProvider({ children }: ToastProviderProps) {
  const contextClass = {
    success: `${styles.success}`,
    error: `${styles.error}`,
    info: `${styles.info}`,
    warning: `${styles.warning}`,
    default: 'bg-indigo-600'
  };

  return (
    <>
      <ToastContainer
        toastClassName={(context) =>
          `${contextClass[context?.type || 'default']} ${styles.toastContainer}`
        }
        // bodyClassName={() => `${styles.toastBody}`}
        position="top-right"
      />
      {children}
    </>
  );
}
